import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from './lib/theme';
import { AuthProvider } from './lib/auth';

import Home from './pages/Home';
import AuthCallback from './pages/AuthCallback';
import GoogleCallback from './pages/GoogleCallback';
import GmailConnectCallback from './pages/GmailConnectCallback';
import AdminLogin from './pages/AdminLogin';
import Pricing from './pages/Pricing';
import { RefundPolicy, Terms, Privacy } from './pages/LegalPages';
import AuditNew from './pages/AuditNew';
import AuditReport from './pages/AuditReport';
import Dashboard from './pages/Dashboard';
import Updates from './pages/Updates';
import Admin from './pages/Admin';
import Account from './pages/Account';
import ProtectedRoute from './pages/ProtectedRoute';
import CookieConsent from './components/CookieConsent';

function AppRouter() {
  const location = useLocation();
  // Fire a GA4 page_view on every SPA route change
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
  // Process OAuth session_id BEFORE any route renders
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/auth/google" element={<GoogleCallback />} />
      <Route path="/gmail-connect" element={<ProtectedRoute><GmailConnectCallback /></ProtectedRoute>} />
      <Route path="/audit/new" element={<AuditNew />} />
      <Route path="/audit/:id" element={<AuditReport />} />
      <Route path="/updates" element={<Updates />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <CookieConsent />
          <Toaster richColors position="top-right" toastOptions={{ className: 'font-sans' }} />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
